export default `query checkGuestOrder ($id: String, $email: String){
checkGuestOrder (id: $id, email: $email) {
status
}
}`
